module.exports = __webpack_public_path__ + "static/media/hat-witch.5c678fe7.svg";